import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { addLocale } from "primereact/api";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { getListaColegio, registroColegio, deleteColegio, updateColegio } from "../../service/Colegio";
import { loading } from "../../actions";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import classNames from "classnames";
import { isNotVacioNull, isEmail, isRun, isLetras, minMax, isValue, isTelefono, getResultValidar } from "../../utilities/Validate";
import { useHistory } from "react-router-dom";
import "./OverlayPanelDemo.css";

export const PageProfesional = () => {
    let ColegioData = {
        id: null,
        rbd: "",
        nombre: "",
        direccion: "",
        region: { idregion: null, region: "" },
        provincia: { idprovincia: null, provincia: "", idregion: null },
        comuna: { idcomuna: null, comuna: "", idprovincia: null },
        telefono: "",
        celular: "",
        email: "",
        fecha_contrato: "",
        fecha_caducidad: "",
        run_director: "",
        nombre_director: "",
        ape_paterno_director: "",
        ape_materno_director: "",
        fijo_director: "",
        celular_director: "",
        email_director: "",
    };

    let ColegioValidate = {
        id: { estado: null, mensaje: "", validar: isValue, minmax: false },
        rbd: { estado: null, mensaje: "Valor requerido con longitud max. 10", validar: isNotVacioNull, minmax: true, min: 1, max: 10 },
        nombre: { estado: null, mensaje: "Valor requerido con longitud min. 5,max. 10", validar: isNotVacioNull, minmax: true, min: 5, max: 100 },
        direccion: { estado: null, mensaje: "Valor requerido con longitud max. 100", validar: isNotVacioNull, minmax: true, min: 1, max: 200 },
        region: { estado: null, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        provincia: { estado: null, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        comuna: { estado: null, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        telefono: { estado: null, mensaje: "Error formato con longitud min. 9,max. 12", validar: isTelefono, minmax: true, min: 1, max: 12 },
        celular: { estado: null, mensaje: "Error formato con longitud min. 9,max. 12", validar: isValue, minmax: false },
        email: { estado: null, mensaje: "Error formato email con longitud max. 45", validar: isEmail, minmax: true, min: 1, max: 45 },
        fecha_contrato: { estado: null, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        fecha_caducidad: { estado: null, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
        run_director: { estado: null, mensaje: "Error formato run", validar: isRun, minmax: false },
        nombre_director: { estado: null, mensaje: "Valor requerido letras con longitud max. 45", validar: isLetras, minmax: true, min: 1, max: 45 },
        ape_paterno_director: { estado: null, mensaje: "Valor requerido letras con longitud max. 45", validar: isLetras, minmax: true, min: 1, max: 45 },
        ape_materno_director: { estado: null, mensaje: "Valor requerido letras con longitud max. 45", validar: isLetras, minmax: true, min: 1, max: 45 },
        fijo_director: { estado: null, mensaje: "Error formato con longitud min. 9,max. 12", validar: isValue, minmax: false },
        celular_director: { estado: null, mensaje: "Valor requerido con longitud min. 9,max. 12", validar: isTelefono, minmax: true, min: 1, max: 12 },
        email_director: { estado: null, mensaje: "Error formato email con longitud max. 45", validar: isEmail, minmax: true, min: 1, max: 45 },
    };

    const dispatch = useDispatch();

    const [colegio, setColegio] = useState(ColegioData);
    const [colegioValidate, setColegioValidate] = useState(ColegioValidate);

    const [dataTable, setDataTable] = useState(null);
    const [globalFilter, setGlobalFilter] = useState("");

    const [regiones, setRegiones] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const [comunas, setComunas] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [detalleDialog, setDetalleDialog] = useState(false);
    const toast = useRef(null);
    const rowData = useRef(null);
    const dataRef = useRef({ titleHeader: "", id: null });

    const [errors, setErrors] = useState({});
    const [value1, setValue1] = useState(0);

    addLocale("es", {
        firstDayOfWeek: 1,
        dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
        dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
        monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
        monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
        today: "Hoy",
        clear: "Claro",
    });

    // Permisos
    const history = useHistory();
    const { usuario } = useSelector((state) => ({
        usuario: state.usuario,
    }));
    //----------------------------

    const loadListaColegio = async () => {
        dispatch(loading(true));
        var data = await getListaColegio(usuario.token);
        if (data.error == 0) {
            setDataTable(data.colegios);
            setRegiones(usuario.general.region);
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }
        dispatch(loading(false));
    };

    useEffect(() => {
        if (colegio.region !== undefined && colegio.region !== "" && colegio.region !== null) {
            setProvincias(usuario.general.provincia.filter((o) => o.idregion == colegio.region.idregion));
            setComunas([]);
        } else {
            setProvincias([]);
            setComunas([]);
            let _ubigeo = { ...colegio };
            _ubigeo["provincia"] = "";
            _ubigeo["comuna"] = "";
            setColegio(_ubigeo);
        }
    }, [colegio.region]);

    useEffect(() => {
        if (colegio.provincia !== undefined && colegio.provincia !== "" && colegio.provincia !== null) {
            setComunas(usuario.general.comuna.filter((o) => o.idprovincia == colegio.provincia.idprovincia));
        } else {
            setComunas([]);
            let _ubigeo = { ...colegio };
            _ubigeo["comuna"] = "";
            setColegio(_ubigeo);
        }
    }, [colegio.provincia]);

    useEffect(() => {
        if (usuario.superusuario) {
            loadListaColegio();
        } else {
            history.push("/Acceso");
        }
    }, []);

    const showDialog = (data) => {
        if (data === null) {
            setColegio(ColegioData);
            dataRef.current.titleHeader = "Nuevo Profesional";
            dataRef.current.id = null;
        } else {
            let dataSelect = { ...data };

            dataSelect.region = usuario.general.region.find((o) => o.idregion === data.idregion);
            dataSelect.comuna = usuario.general.comuna.find((o) => o.idcomuna === data.idcomuna);
            dataSelect.provincia = usuario.general.provincia.find((o) => o.idprovincia === data.idprovincia);

            let fecha_caducidad = new Date(data.fecha_caducidad);
            fecha_caducidad.setMinutes(fecha_caducidad.getMinutes() + fecha_caducidad.getTimezoneOffset());
            dataSelect.fecha_caducidad = fecha_caducidad;

            let fecha_contrato = new Date(data.fecha_contrato);
            fecha_contrato.setMinutes(fecha_contrato.getMinutes() + fecha_contrato.getTimezoneOffset());
            dataSelect.fecha_contrato = fecha_contrato;

            setColegio({ ...dataSelect });

            dataRef.current.titleHeader = "Actualizar Profesional";
            dataRef.current.id = data.id;
        }
        setDetalleDialog(true);
    };

    const hideDialog = () => {
        setSubmitted(false);
        setDetalleDialog(false);
    };

    const monthNavigatorTemplate = (e) => {
        return <Dropdown value={e.value} options={e.options} onChange={(event) => e.onChange(event.originalEvent, event.value)} style={{ lineHeight: 1 }} />;
    };

    const yearNavigatorTemplate = (e) => {
        return <Dropdown value={e.value} options={e.options} onChange={(event) => e.onChange(event.originalEvent, event.value)} className="ml-2" style={{ lineHeight: 1 }} />;
    };

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || "";
        let _detalla = { ...colegio };
        _detalla[`${name}`] = val;
        setColegio(_detalla);
    };

    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        );
    };

    const bodyTemplateDate = (data, props) => {
        if (data[props.field] === null) {
            return (
                <>
                    <span className="p-column-title">{props.header}</span>
                    {data[props.field]}
                </>
            );
        } else {
            return (
                <>
                    <span className="p-column-title">{props.header}</span>

                    {moment(data[props.field]).format("DD/MM/YYYY")}
                </>
            );
        }
    };

    const saveRegistro = async () => {
        setSubmitted(true);

        let validado = getResultValidar(colegio, colegioValidate);

        setColegioValidate(validado.result);

        if (validado.registra) {
            if (dataRef.current.id === null) {
                let data = await registroColegio(colegio, usuario.token);
                if (data.error == 0) {
                    toast.current.show({ severity: "success", summary: "OK", detail: "Se eliminó el colegio", life: 3000 });
                    loadListaColegio();
                    hideDialog();
                } else {
                    if (data.error == 1) {
                        toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                    } else {
                        console.log("Error");
                    }
                }
            } else {
                let data = await updateColegio(colegio, usuario.token);
                if (data.error == 0) {
                    toast.current.show({ severity: "success", summary: "OK", detail: "Se actualizó el colegio", life: 3000 });
                    loadListaColegio();
                    hideDialog();
                } else {
                    if (data.error == 1) {
                        toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                    } else {
                        console.log("Error");
                    }
                }
            }
        }
    };

    const accept = async () => {
        let data = await deleteColegio(dataRef.current.id, usuario.token);
        if (data.error == 0) {
            toast.current.show({ severity: "success", summary: "OK", detail: "Se eliminó el colegio", life: 3000 });
            loadListaColegio();
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }
    };

    const confirmDelete = (row) => {
        dataRef.current.id = row.id;
        confirmDialog({
            message: "Estas seguro de eliminar el registro?",
            header: "Eliminar Confirmar",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept,
        });
    };

    const estadoContrato = (rowData) => {
        let contrato = moment(rowData.fecha_contrato);
        let caducidad = moment(rowData.fecha_caducidad);
        let dias = caducidad.diff(contrato, "days");
        let color = "";
        if (dias > 30) {
            color = "green";
        } else if (dias >= 15 && dias < 30) {
            color = "orange";
        } else {
            color = "red";
        }
        return <div style={{ backgroundColor: color, width: "100%", padding: 7, radius: "2px", justifyContent: "center", borderRadius: "4px" }}></div>;
    };

    const actionBodyHerramientas = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger p-mr-2" onClick={() => confirmDelete(rowData)} />
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-mr-2" onClick={() => showDialog(rowData)} />
            </div>
        );
    };

    const dataTableHeader = (
        <div className="table-header">
            <span className="p-input-icon-left">
                <i className="pi pi-search" />

                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
            </span>

            <div className="flex align-items-center export-buttons">
                <Button type="button" label="PROFESIONAL" icon="pi pi-plus" className="mr-2 p-mr-1" onClick={() => showDialog(null)}></Button>
                <Button type="button" icon="pi pi-refresh" className="mr-2" onClick={loadListaColegio}></Button>
            </div>
        </div>
    );

    const dialogFooter = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Registrar" icon="pi pi-check" onClick={saveRegistro} />
        </>
    );

    return (
        <div className="p-grid table-demo">
            <div className="p-col-12">
                <Toast ref={toast} />

                <DataTable value={dataTable} paginator id="1773" className="p-datatable-customers p-datatable-sm" rows={10} dataKey="id" rowHover globalFilter={globalFilter} emptyMessage="No existe información!" loading={false} header={dataTableHeader} scrollable scrollHeight="flex">
                    <Column headerStyle={{ width: "8rem", textAlign: "center" }} bodyStyle={{ textAlign: "center", overflow: "visible", justifyContent: "center" }} field="rbd" header="RBD" sortable body={bodyTemplate}></Column>
                    <Column field="nombre" header="Nombre" sortable body={bodyTemplate}></Column>
                    <Column field="direccion" header="Dirección" sortable body={bodyTemplate}></Column>
                    <Column field="telefono" header="Teléfono" sortable body={bodyTemplate}></Column>

                    {/*
            <Column field="email" header="Email" sortable body={bodyTemplate}></Column>*/}
                    <Column field="fecha_contrato" header="Fecha Contrato" sortable body={bodyTemplateDate}></Column>
                    <Column field="fecha_caducidad" header="Fecha Caducidad" sotable body={bodyTemplateDate}></Column>
                    <Column headerStyle={{ width: "6rem", textAlign: "center" }} bodyStyle={{ textAlign: "center", overflow: "visible", justifyContent: "center" }} header="Estado" sortable body={estadoContrato}></Column>
                    {/*<Column field="run_director" header="run Director" sortable body={bodyTemplate}></Column>*/}
                    <Column field="nombre_director" header="Director" sortable body={bodyTemplate}></Column>
                    <Column field="ape_paterno_director" header="Paterno" sortable body={bodyTemplate}></Column>
                    <Column field="ape_materno_director" header="Materno" sortable body={bodyTemplate}></Column>
                    {/* <Column field="fijo_director" header="Fijo" sortable body={bodyTemplate}></Column> 
          <Column field="celular_director" header="Celular" sortable body={bodyTemplate}></Column>*/}
                    {/* <Column field="email_director" header="Email Director" sortable body={bodyTemplate}></Column> */}
                    <Column headerStyle={{ width: "8rem", textAlign: "center" }} bodyStyle={{ textAlign: "center", overflow: "visible", justifyContent: "center" }} body={actionBodyHerramientas}></Column>
                </DataTable>

                <Dialog visible={detalleDialog} style={{ width: "50vw" }} header={dataRef.current.titleHeader} modal className="p-fluid" footer={dialogFooter} onHide={hideDialog}>
                    <div className="p-formgrid p-grid p-col-12 p-p-0 p-mt-0">
                        <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                            <label htmlFor="name2">RBD</label>
                            <InputText id="name2" type="text" maxLength={9} value={colegio.rbd == null ? "" : colegio.rbd} autoFocus onChange={(e) => onInputChange(e, "rbd")} required className={classNames({ "p-invalid": submitted && !colegioValidate.rbd.estado })} />
                            {submitted && !colegioValidate.rbd.estado && (
                                <small style={{ color: "#dc3545" }} className="p-invalid">
                                    {colegioValidate.rbd.mensaje}
                                </small>
                            )}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                            <label htmlFor="name2">Nombre</label>
                            <InputText id="name2" type="text" value={colegio.nombre == null ? "" : colegio.nombre} onChange={(e) => onInputChange(e, "nombre")} required className={classNames({ "p-invalid": submitted && !colegioValidate.nombre.estado })} />
                            {submitted && !colegioValidate.nombre.estado && (
                                <small style={{ color: "#dc3545" }} className="p-invalid">
                                    {colegioValidate.nombre.mensaje}
                                </small>
                            )}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                            <label htmlFor="name2">DIRECCIÓN</label>
                            <InputText id="name2" type="text" value={colegio.direccion == null ? "" : colegio.direccion} onChange={(e) => onInputChange(e, "direccion")} required className={classNames({ "p-invalid": submitted && !colegioValidate.direccion.estado })} />
                            {submitted && !colegioValidate.direccion.estado && (
                                <small style={{ color: "#dc3545" }} className="p-invalid">
                                    {colegioValidate.direccion.mensaje}
                                </small>
                            )}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                            <label htmlFor="name2">REGIÓN</label>
                            <Dropdown value={colegio.region} options={regiones} onChange={(e) => onInputChange(e, "region")} optionLabel="region" filter showClear filterBy="region" placeholder="Seleccionar..." />
                            {submitted && !colegioValidate.region.estado && (
                                <small style={{ color: "#dc3545" }} className="p-invalid">
                                    {colegioValidate.region.mensaje}
                                </small>
                            )}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                            <label htmlFor="name2">PROVINCIA</label>
                            <Dropdown value={colegio.provincia} options={provincias} onChange={(e) => onInputChange(e, "provincia")} optionLabel="provincia" filter showClear filterBy="provincia" placeholder="Seleccionar..." />
                            {submitted && !colegioValidate.provincia.estado && (
                                <small style={{ color: "#dc3545" }} className="p-invalid">
                                    {colegioValidate.provincia.mensaje}
                                </small>
                            )}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                            <label htmlFor="name2">COMUNA</label>
                            <Dropdown value={colegio.comuna} options={comunas} onChange={(e) => onInputChange(e, "comuna")} optionLabel="comuna" filter showClear filterBy="comuna" placeholder="Seleccionar..." />
                            {submitted && !colegioValidate.comuna.estado && (
                                <small style={{ color: "#dc3545" }} className="p-invalid">
                                    {colegioValidate.comuna.mensaje}
                                </small>
                            )}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                            <label htmlFor="txtDireccion">TELÉFONO</label>
                            <InputText id="txtDireccion" type="tel" value={colegio.telefono == null ? "" : colegio.telefono} onChange={(e) => onInputChange(e, "telefono")} required className={classNames({ "p-invalid": submitted && !colegioValidate.telefono.estado })} />
                            {submitted && !colegioValidate.telefono.estado && (
                                <small style={{ color: "#dc3545" }} className="p-invalid">
                                    {colegioValidate.telefono.mensaje}
                                </small>
                            )}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                            <label htmlFor="name2">CELULAR</label>
                            <InputText id="name2" type="text" value={colegio.celular == null ? "" : colegio.celular} onChange={(e) => onInputChange(e, "celular")} required className={classNames({ "p-invalid": submitted && !colegioValidate.celular.estado })} />
                            {submitted && !colegioValidate.celular.estado && (
                                <small style={{ color: "#dc3545" }} className="p-invalid">
                                    {colegioValidate.celular.mensaje}
                                </small>
                            )}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                            <label htmlFor="email2">EMAIL</label>
                            <InputText id="email2" type="text" value={colegio.email == null ? "" : colegio.email} onChange={(e) => onInputChange(e, "email")} required className={classNames({ "p-invalid": submitted && !colegioValidate.email.estado })} />
                            {submitted && !colegioValidate.email.estado && (
                                <small style={{ color: "#dc3545" }} className="p-invalid">
                                    {colegioValidate.email.mensaje}
                                </small>
                            )}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                            <label htmlFor="name2">FECHA CONTRATO</label>
                            <Calendar
                                id="spanish"
                                value={colegio.fecha_contrato}
                                onChange={(e) => onInputChange(e, "fecha_contrato")}
                                locale="es"
                                dateFormat="dd/mm/yy"
                                monthNavigator
                                yearNavigator
                                yearRange="2020:2030"
                                showIcon
                                monthNavigatorTemplate={monthNavigatorTemplate}
                                yearNavigatorTemplate={yearNavigatorTemplate}
                            />
                            {submitted && !colegioValidate.fecha_contrato.estado && (
                                <small style={{ color: "#dc3545" }} className="p-invalid">
                                    {colegioValidate.fecha_contrato.mensaje}
                                </small>
                            )}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                            <label htmlFor="name2">FECHA CADUCA</label>
                            <Calendar
                                id="spanish"
                                value={colegio.fecha_caducidad}
                                onChange={(e) => onInputChange(e, "fecha_caducidad")}
                                locale="es"
                                dateFormat="dd/mm/yy"
                                monthNavigator
                                yearNavigator
                                yearRange="2020:2030"
                                showIcon
                                monthNavigatorTemplate={monthNavigatorTemplate}
                                yearNavigatorTemplate={yearNavigatorTemplate}
                            />
                            {submitted && !colegioValidate.fecha_caducidad.estado && (
                                <small style={{ color: "#dc3545" }} className="p-invalid">
                                    {colegioValidate.fecha_caducidad.mensaje}
                                </small>
                            )}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                            <label htmlFor="email2">RUN DIRECTOR</label>
                            <InputText id="email2" type="text" value={colegio.run_director == null ? "" : colegio.run_director} onChange={(e) => onInputChange(e, "run_director")} required className={classNames({ "p-invalid": submitted && !colegioValidate.run_director.estado })} />
                            {submitted && !colegioValidate.run_director.estado && (
                                <small style={{ color: "#dc3545" }} className="p-invalid">
                                    {colegioValidate.run_director.mensaje}
                                </small>
                            )}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                            <label htmlFor="email2">NOMBRE DIRECTOR</label>
                            <InputText id="email2" type="text" value={colegio.nombre_director == null ? "" : colegio.nombre_director} onChange={(e) => onInputChange(e, "nombre_director")} required className={classNames({ "p-invalid": submitted && !colegioValidate.nombre_director.estado })} />
                            {submitted && !colegioValidate.nombre_director.estado && (
                                <small style={{ color: "#dc3545" }} className="p-invalid">
                                    {colegioValidate.nombre_director.mensaje}
                                </small>
                            )}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                            <label htmlFor="email2">PATERNO</label>
                            <InputText
                                id="email2"
                                type="text"
                                value={colegio.ape_paterno_director == null ? "" : colegio.ape_paterno_director}
                                onChange={(e) => onInputChange(e, "ape_paterno_director")}
                                required
                                className={classNames({ "p-invalid": submitted && !colegioValidate.ape_paterno_director.estado })}
                            />
                            {submitted && !colegioValidate.ape_paterno_director.estado && (
                                <small style={{ color: "#dc3545" }} className="p-invalid">
                                    {colegioValidate.ape_paterno_director.mensaje}
                                </small>
                            )}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                            <label htmlFor="email2">MATERNO</label>
                            <InputText
                                id="email2"
                                type="text"
                                value={colegio.ape_materno_director == null ? "" : colegio.ape_materno_director}
                                onChange={(e) => onInputChange(e, "ape_materno_director")}
                                required
                                className={classNames({ "p-invalid": submitted && !colegioValidate.ape_materno_director.estado })}
                            />
                            {submitted && !colegioValidate.ape_materno_director.estado && (
                                <small style={{ color: "#dc3545" }} className="p-invalid">
                                    {colegioValidate.ape_materno_director.mensaje}
                                </small>
                            )}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                            <label htmlFor="email2">TELÉFONO DIRECTOR</label>
                            <InputText id="email2" type="text" value={colegio.fijo_director == null ? "" : colegio.fijo_director} onChange={(e) => onInputChange(e, "fijo_director")} required className={classNames({ "p-invalid": submitted && !colegioValidate.fijo_director.estado })} />
                            {submitted && !colegioValidate.fijo_director.estado && (
                                <small style={{ color: "#dc3545" }} className="p-invalid">
                                    {colegioValidate.fijo_director.mensaje}
                                </small>
                            )}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                            <label htmlFor="email2">CELULAR DIRECTOR</label>
                            <InputText id="email2" type="text" value={colegio.celular_director == null ? "" : colegio.celular_director} onChange={(e) => onInputChange(e, "celular_director")} required className={classNames({ "p-invalid": submitted && !colegioValidate.celular_director.estado })} />
                            {submitted && !colegioValidate.celular_director.estado && (
                                <small style={{ color: "#dc3545" }} className="p-invalid">
                                    {colegioValidate.celular_director.mensaje}
                                </small>
                            )}
                        </div>
                        <div className="p-col-12 p-md-6 p-lg-4 p-mt-2">
                            <label htmlFor="email2">EMAIL DIRECTOR</label>
                            <InputText id="email2" type="email" value={colegio.email_director == null ? "" : colegio.email_director} onChange={(e) => onInputChange(e, "email_director")} required className={classNames({ "p-invalid": submitted && !colegioValidate.email_director.estado })} />
                            {submitted && !colegioValidate.email_director.estado && (
                                <small style={{ color: "#dc3545" }} className="p-invalid">
                                    {colegioValidate.email_director.mensaje}
                                </small>
                            )}
                        </div>
                    </div>
                </Dialog>
            </div>
        </div>
    );
};
